<template>
    <div class="cus-container">
        <!-- title -->
        <h1 class="main-title">
            <span>
                {{$t('testingLab.title')}}
                <hr>
            </span>
        </h1>
        <!-- customer content  -->
        <div class="row cus-row">
            <p>{{$t('testingLab.introText')}}</p>
            <img src="../../assets/images/CNAS-logo.png" class="img-responsive" alt="" style="margin:0 auto;margin-top:2rem;">
        </div>
        <!-- case list -->
        <div class="row core-row">
            <div class="col-sm-6">
                <div class="prototy-item">
                    <h1>{{$t('testingLab.mechanical.title')}}</h1>
                    <p v-html="$t('testingLab.mechanical.text')"></p>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="manufact-item">
                    <h1>{{$t('testingLab.material.title')}}</h1>
                    <p v-html="$t('testingLab.material.text')"></p>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="integration-item">
                    <h1>{{$t('testingLab.environmental.title')}}</h1>
                    <p v-html="$t('testingLab.environmental.text')"></p>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="testing-item">
                    <h1>{{$t('testingLab.other.title')}}</h1>
                    <p v-html="$t('testingLab.other.text')"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                
            }
        },
        methods:{
            
        },
        mounted(){
            $(document).ready(function(){
                if($(window).width()>768){
                    $(".core-row .col-sm-6>div").height($(".core-row .col-sm-6>div").width()*2/3)
                }
            })
        }
    }
</script>

<style scoped>
    .core-row{
        max-width:100% !important;
        padding:0 10rem;
    }
    .prototy-item{
        background:#00457A;
        padding:5rem;
    }
    .manufact-item{
        background: #808080;
        padding:5rem;
    }
    .integration-item{
        background: #2BAADF;
        padding:5rem;
    }
    .testing-item{
        background: #0F2038;
        padding:5rem;
    }
    .core-row .col-sm-6{
        padding:2rem;
    }
    .core-row h1{
        font-size: 3rem;
        color: #fff;
        text-align: left;
    }
    .core-row p{
        width: 100% !important;
        color: #fff;
        text-align: left;
        font-size: 1.6rem;
        line-height: 1.5;
        margin-top:3rem;
        padding: 0 !important;
    }
    @media (min-width:768px) and (max-width:1024px){
        .core-row{
            padding:0 4rem;
        }
        .prototy-item,.manufact-item,.integration-item,.testing-item{
            padding:2rem;
        }
        .integration-item{
            padding-bottom: 8rem;
        }
        .testing-item{
            padding-bottom: 3rem;
        }
        .core-row h1{
            font-size: 2.4rem;
        }
    }
    @media (max-width: 767px){
        .core-row{
            padding:0;
        }
        .prototy-item{
            padding:1rem;
        }
        .manufact-item{
            padding:1rem;
        }
        .integration-item{
            padding:1rem;
        }
        .testing-item{
            padding:1rem;
        }
        .core-row .col-sm-6{
            padding:1rem;
        }
        .core-row h1{
            font-size: 1.5rem;
        }
        .core-row p{
            font-size: .8rem;
            margin-top:1.5rem;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/Services/TestingLaboratory.vue